export default __webpack_public_path__ + "static/media/MarketLauncher.feb3f5aa.png";